import {
    DEFAULT_PERIOD_SEARCH,
    resolvePeriodRange,
    validatePeriodSearch,
} from '../report-period'
import type { ReportPeriodSearch } from '../report-period'

/** Bộ lọc báo cáo công nợ: kỳ chung + khách + khoảng nợ cuối kỳ. */
export interface DebtReportSearch extends ReportPeriodSearch {
    q?: string
    min?: number
    max?: number
}

export const DEFAULT_DEBT_SEARCH: DebtReportSearch = DEFAULT_PERIOD_SEARCH

const num = (v: unknown): number | undefined => {
    const n =
        typeof v === 'number'
            ? v
            : typeof v === 'string' && v.trim() !== ''
              ? Number(v)
              : NaN
    return Number.isFinite(n) ? n : undefined
}

/** validateSearch của route: giá trị lạ bị bỏ thay vì đẩy xuống API. */
export function validateDebtReportSearch(
    raw: Record<string, unknown>,
): DebtReportSearch {
    const q = typeof raw.q === 'string' && raw.q.trim() ? raw.q : undefined
    return {
        ...validatePeriodSearch(raw),
        q,
        min: num(raw.min),
        max: num(raw.max),
    }
}

export const resolveDebtRange = resolvePeriodRange
